import React from 'react';
import { PNGS } from '../../assets';
import './replace-customer.scss';
import { CommonButton } from '../button';
export const ReplaceCustomer = () => {
  return (
    <div className="replace-customer-container">
      <img src={PNGS.ReplaceCustomerIcon} alt="" />
      <div className="replace-customer-container-body">
        <div className="replace-customer-container-body-title font-semibold">
          Replace Customer?
        </div>
        <div className="replace-customer-container-body-subtitle font-regular">
          Are you sure you want to Replace this customer?
        </div>
      </div>
      <div className="replace-customer-container-footer">
        <CommonButton
          onPress={() => {}}
          text={'Cancel'}
          buttonStyle="replace-customer-container-footer-cancel-btn"
        />
        <CommonButton
          onPress={() => {}}
          text={'Replace'}
          buttonStyle="replace-customer-container-footer-replace-btn"
        />
      </div>
    </div>
  );
};
